import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import { getBaseItemResponseShape } from 'owa-mail-store/lib/utils/getBaseItemResponseShape';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';

export default function getRightsManagementLicenseData(
    itemId: string
): Promise<RightsManagementLicenseDataType> {
    return getItem([itemId], getBaseItemResponseShape(), 'ItemNormalizedBody')
        .then(responseMessage => {
            const response = responseMessage[0] as ItemInfoResponseMessage;
            if (checkIfResponseSuccess(response)) {
                return response.Items[0].RightsManagementLicenseData;
            } else {
                return null;
            }
        })
        .catch((error: Error) => {
            return null;
        });
}
